import React from 'react';
import Col from 'react-bootstrap/Col';
import classes from './Sec2Comp.module.css'
import img1 from '../../../assets/img/img_1.png';
import img2 from '../../../assets/img/img_2.png';
import img3 from '../../../assets/img/img_3.png';
import img4 from '../../../assets/img/img_4.png';
import img5 from '../../../assets/img/img_5.png';
import img6 from '../../../assets/img/img_6.png';
import Row from 'react-bootstrap/esm/Row';

const sec2Data = [
    {
        img:img1,
        title:"Zero Typing Effort",
        subTitle:"Create Question Papers with just few clicks without actually typing the texts."
    },
    {
        img:img2,
        title:"Never a Delayed Doubt",
        subTitle:"Answer your student’s doubt quickly, easily and effectively at your comfort."
    },
    {
        img:img3,
        title:"Vast Question Bank",
        subTitle:"Access to a database of 3 lakhs + verified questions with solutions."
    },
    {
        img:img4,
        title:"Create Practice Sheets and papers",
        subTitle:"Create anything from a practice sheet to a full-length question paper."
    },
    {
        img:img5,
        title:"Multiple Device Access",
        subTitle:"Avail all the features on both Mobile App as well as on your computer."
    },
    {
        img:img6,
        title:"Easy Customization",
        subTitle:"Customize papers as questions are tagged by topic, sub-topic and difficulty levels."
    }
]

const SecComp = props => {
    return (
        <Col lg={6} md={6} sm={12} className='my-3'>
        <Row>
        <Col lg={2} md={4} sm={4} xs={4} className='text-end'>
            <img className='img-fluid' src={props.img} alt='' />
        </Col>
        <Col lg={8} md={8} sm={8} xs={8} className={classes['sec2-comp-col2']}>
        <h4>{props.title}</h4>
        <p>{props.subTitle}</p>
        </Col>
        </Row>
    </Col>
    );
}

const Sec2Comp = () => {
  return (
    <>
    {sec2Data.map(data => 
        <SecComp
        key={data.img} 
        img={data.img}
        title={data.title}
        subTitle={data.subTitle} />
    )}
    </>
  )
}

export default Sec2Comp